import { useState, useDebugValue } from 'react';

export const useThrottle = (func, delay) => {
  const [timeout, saveTimeout] = useState(null);
  useDebugValue(delay);
  function throttledFunc(...args) {
    if (timeout) {
      clearTimeout(timeout);
    }

    const newTimeout = setTimeout(() => {
      func(...args);
      if (newTimeout === timeout) {
        saveTimeout(null);
      }
    }, delay);
    saveTimeout(newTimeout);
  }

  return throttledFunc;
};
